"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
function isSelected(opt, value, valueKey) {
  return (0, _lodash.findIndex)(value, function (v) {
    return (0, _lodash.get)(v, valueKey, '') === (0, _lodash.get)(opt, valueKey, undefined);
  }) >= 0;
}
var _default = exports["default"] = isSelected;